import request from './request.js'


// 获取图片验证码
export const getCode_api = data => {
  return request({
    method: "post",
    url: '/api/oauth/captcha',
    data
  })
}

//登陆
export const login_api = data => {
  return request({
    method: "post",
    url: '/api/oauth/token',
    data
  })
}

//获取账号类型
export const accountType_api = data => {
  return request({
    method: "post",
    url: '/api/account/type',
    data
  })
}

//获取账号信息
export const accountInfo_api = data => {
  return request({
    method: "post",
    url: '/api/account/info',
    data
  })
}


//获取课程列表
export const courseList_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/course',
    data
  })
}

//获取课程列表
export const courseCategory_api = data => {
  return request({
    method: "post",
    url: 'api/simulation/course/category',
    data
  })
}

//课程添加任务
export const createTask_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/task/create',
    data
  })
}

//班级列表
export const classList_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/class',
    data
  })
}

//课程详情
export const courseShow_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/course/:id/show',
    data
  })
}

//任务列表
export const taskList_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/task',
    data
  })
}


//删除任务
export const taskDelete_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/task/:id/delete',
    data
  })
}

//任务成绩列表
export const taskScore_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/task/:task_id/student/score',
    data
  })
}

//任务成绩详情
export const taskScoreShow_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/task/:id/student/:stu_id/score',
    data
  })
}


//课程学习记录
export const courseStudied_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/course/:course_id/student/score',
    data
  })
}

//成绩-根据课程id
export const courseStuDetails_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/course/:course_id/student/:stu_id/score',
    data
  })
}


//根据仿真班级ID获取学生列表
export const studentList_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/class/:simulation_class_id/student',
    data
  })
}

//删除班级
export const classDelete_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/class/:class_id/delete',
    data
  })
}

//所有学生列表
export const studentSelect_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/student/select',
    data
  })
}

//班级添加学生
export const studentAdd_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/class/:simulation_class_id/student/check',
    data
  })
}

//学校班级列表
export const classSelect_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/school/class/select',
    data
  })
}

//添加班级
export const classCreate_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/class/create',
    data
  })
}

//学生课程列表
export const studentCourse_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/student/course',
    data
  })
}

//仿真实训任务清单
export const studentTask_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/task',
    data
  })
}

//学生 任务课程列表
export const studentTask_course_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/student/task/course',
    data
  })
}


//根据任务ID获取任务详情
export const taskShow_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/task/:id/show',
    data
  })
}

//根据任务ID修改任务内容
export const taskUpdate_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/task/:id/update',
    data
  })
}


//根据ID获取班级详情
export const classShow_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/class/:id/show',
    data
  })
}


//根据ID修改班级信息
export const classUpdate_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/class/:id/update',
    data
  })
}

//修改密码
export const accountUpdate_api = data => {
  return request({
    method: "post",
    url: '/api/account/update',
    data
  })
}

//课程成绩详情
export const studentScore_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/student/course/:id/score',
    data
  })
}
//任务成绩详情
export const taskScoreDetails_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/student/task/:id/course/score',
    data
  })
}

// 根据ID修改任务成绩
export const score_update_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/task/score_update',
    data
  })
}

// 导出成绩
export const score_export_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/task/score_export',
    data
  })
}


// 学生端获取任务
export const owner_task_api = data => {
  return request({
    method: "post",
    url: '/api/simulation/student/owner_task',
    data
  })
}

//获取title
export const getTitle_api = data => {
  return request({
    method: "post",
    url: '/api/config',
    data
  })
}
//获取配置信息
export const pcconfig_api = data => {
  return request({
    method: "post",
    url: '/api/pcconfig',
    data
  })
}


// 导出成绩
export const student_score_export = data => {
  return request({
    method: "get",
    url: `/api/simulation/task/${data.task_id}/student/${data.stu_id}/student_score_export`,
  })
}
// 总览成绩
export const student_score_list_export = data => {
  return request({
    method: "get",
    url: `api/simulation/task/${data.task_id}/student/student_score_list_export`,
  })
}
// 批量成绩
export const student_score_batch_export = data => {
  return request({
    method: "get",
    url: `api/simulation/task/${data.task_id}/student/student_score_batch_export`,
  })
}


// 课程导出成绩
export const score_detail_export = data => {
  return request({
    method: "get",
    url: `/api/simulation/course/${data.task_id}/student/${data.stu_id}/score_detail_export`,
  })
}
// 课程总览成绩
export const score_export = data => {
  return request({
    method: "get",
    url: `api/simulation/course/${data.task_id}/student/score_export`,
  })
}
// 课程批量成绩
export const score_batch_export = data => {
  return request({
    method: "get",
    url: `api/simulation/course/${data.task_id}/student/score_batch_export`,
  })
}



// WEBPACK FOOTER //
// ./src/http/api.js